import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgNetEnt = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 128 40"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="#000"
        d="M20.727 7C17.546 7 15 9.568 15 12.778V33h92.273c3.182 0 5.727-2.568 5.727-5.778V7zm14.318 20.543c0 .642-.477 1.284-1.272 1.284h-2.864l-7.477-11.716v11.716h-3.5v-16.37c0-.642.477-1.284 1.273-1.284h2.864l7.477 11.716V11.173h3.5zm12.728.321c0 .482-.637.963-1.114.963h-9.545v-16.37c0-.642.477-1.284 1.272-1.284H48.41l-.954 3.37h-6.682v3.37H46.5l-.795 3.05h-4.932v3.852h7.636l-.636 2.407zm14.954-13.32h-4.454v12.839c0 .642-.478 1.284-1.273 1.284h-2.386V14.704h-5.091l.636-2.408c0-.481.636-.963 1.114-.963h12.409l-.955 3.37zm12.41 13.32c0 .482-.637.963-1.114.963h-9.546V20l2.068-7.704c0-.481.637-.963 1.114-.963h7.955l-.955 3.37h-6.682v3.371h5.727l-.795 3.05h-4.932v3.851h7.637l-.637 2.408zm17.5-.32c0 .641-.478 1.283-1.273 1.283H88.5l-7.477-11.716v11.716h-3.5v-16.37c0-.642.477-1.284 1.272-1.284h2.865l7.476 11.716V11.173h3.5zm15.272-13h-4.454v12.839c0 .642-.478 1.284-1.273 1.284h-2.387V14.704h-5.09v-2.087c0-.642.477-1.284 1.272-1.284h13.046l-.955 3.37z"
      />
    </svg>
  );
};
export default SvgNetEnt;
